import React from 'react';
import { isSceneDark, darkScene, lightScene } from 'ducks/layout';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import SceneAction from '../SceneAction';
import { useAppDispatch } from 'ducks/hooks';
import { useCore } from 'contexts/core';
import { NightLightsSystem } from '@inter-ikea-storageone/range';
import Icon from '@ingka/ssr-icon/paths/dark-mode';

const LightsAction = (props: React.PropsWithoutRef<JSX.IntrinsicElements['button']>) => {
  const { formatMessage } = useIntl();
  const active = useSelector(isSceneDark);
  const dispatch = useAppDispatch();

  const coreApi = useCore();

  return (
    <SceneAction
      {...props}
      label={
        active
          ? formatMessage({ id: 'storageone.sceneMenuShowDaytimeMode' })
          : formatMessage({ id: 'storageone.sceneMenuShowNightMode' })
      }
      dataTestId="light-toggle"
      onClick={() => {
        if (active) {
          dispatch(lightScene());
          coreApi.getSystem<NightLightsSystem>('NightLightsSystem')?.disable();
        } else {
          dispatch(darkScene());
          coreApi.getSystem<NightLightsSystem>('NightLightsSystem')?.enable();
        }
      }}
      ssrIcon={Icon}
      enabled={active}
    />
  );
};

export default LightsAction;
